import { SET_CARD_DATA, CLEAR_CARD } from './constants';

export const setCardData = (card) => ({
  type: SET_CARD_DATA,
  card,
});

export const clearCard = () => ({ type: CLEAR_CARD });
